import { Component } from '@angular/core';

@Component({
  selector: 'app-kyc',
  imports: [],
  templateUrl: './kyc.component.html',
  styleUrl: './kyc.component.css',
})
export class KycComponent {

}
